import { Clipboard } from '@capacitor/clipboard';

export const writeToNativeClipboard = async (clipboardText: string): Promise<void> => {
    await Clipboard.write({
        string: clipboardText,
    });
};
